import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
export var Heading = forwardRefAs(function (_a, ref) {
  var className = _a.className,
      rest = tslib_1.__rest(_a, ["className"]);

  return React.createElement(Generic, Object.assign({
    className: classNames("heading", className),
    ref: ref
  }, rest));
}, {
  as: "p"
});
Heading.displayName = "Heading";